export default __webpack_public_path__ + "static/media/07.8bb2bb25.png";